/**
 * StatusType describes the global status of the checkout
 * IDLE -> SUBMITTING -> PROCESSING -> SUCCEEDED || FAILED
 */

export enum StatusType {
  IDLE = 'idle', // default status
  SUBMITTING = 'submitting', // donor has clicked "Donate Now"
  PROCESSING = 'processing', // order is processing
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
  COMPLETED = 'completed',
}

export type StatusSlice = {
  status: string
  error: null | string
}
